import {lazy} from "react";
import {ReviewMapping} from "./Constant";

export const ReviewRouterComponent = lazy(() => import('./view/ReviewRouterComponent'));
export const ReviewSingleBranch = lazy(() => import('./view/ReviewSingleBranch'));

export default [
    {id: ReviewMapping.history, exact: true, component: ReviewRouterComponent},
    {id: ReviewMapping.historyDetail, exact: true, component: ReviewSingleBranch},
];